<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span class="question__txt">まず、あなたの生年月日と性別をおしえてください。</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--select"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_1"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="select--col3">
            <select
              v-model="birthYear"
              title="birthYear"
              @change="changeBirthYearAction"
              :class="{fontBlack: isBirthYearFontBlack}"
            >
              <option class="placeholder" value="" style="display: none;">年</option>
              <option
                v-for="year in arrYear"
                :key="year"
                :value="year"
              >{{ year }}年</option>
            </select>
            <select
              v-model="birthMonth"
              title="birthMonth"
              @change="changeBirthMonthAction"
              :class="{fontBlack: isBirthMonthFontBlack}"
            >
              <option class="placeholder" value="" style="display: none;">月</option>
              <option
                v-for="month in 12"
                :key="month"
                :value="month"
              >{{ month }}月</option>
            </select>
            <select
              v-model="birthDay"
              title="birthDay"
              @change="changeBirthDayAction"
              :class="{fontBlack: isBirthDayFontBlack}"
            >
              <option class="placeholder" value="" style="display: none;">日</option>
              <option
                v-for="day in 31"
                :key="day"
                :value="day"
              >{{ day }}日</option>
            </select>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--radio"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_2"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="radio--col2">
            <label>
              <input type="radio" v-model="gender" :value="genderConst.man" @change="changeGenderAction"> {{ displayGender(genderConst.man) }}
            </label>
            <label>
              <input type="radio" v-model="gender" :value="genderConst.woman" @change="changeGenderAction"> {{ displayGender(genderConst.woman) }}
            </label>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled"
          @click.once="clickFixBirthdayAndGender"
          @click="changeFixBirthdayAndGender"
        >{{ btnContent }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ $parent.formData.birth_year }}年{{ $parent.formData.birth_month }}月{{ $parent.formData.birth_day }}日生まれの{{ displayGender($parent.formData.sex) }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GenderMixin from '../../mixins/GenderMixin'
import functionsMixin from '../../mixins/functionsMixin'
import WritingAnimation from '../animations/WritingAnimation'

export default {
  name: 'FormBirthdayAndGender',
  mixins: [GenderMixin, functionsMixin],
  components: {
    WritingAnimation
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        question: false,
        answer_1: false,
        answer_2: false,
        next: false,
        fix: false,
        writing_2: false,
        confirmMessage: false
      },
      isDisabled: true,
      isFix: false,
      btnContent: '次へ',
      birthYear: '',
      birthMonth: '',
      birthDay: '',
      gender: 0,
      arrYear: [],
      isBirthYearFontBlack: false,
      isBirthMonthFontBlack: false,
      isBirthDayFontBlack: false
    }
  },
  mounted: function () {
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.question = true
      this.autoScroll()
      setTimeout(function () {
        this.show.answer_1 = true
        this.show.answer_2 = true
        this.autoScroll()
      }.bind(this), 500)
    }.bind(this), 1000)
    let today = new Date()
    for (let y = (today.getFullYear() - 30); y <= (today.getFullYear() - 11); y++) {
      this.arrYear.push(y)
    }
  },
  watch: {
    birthYear: function () {
      // this.showNext()
    },
    birthMonth: function () {
      // this.showNext()
    },
    birthDay: function () {
      // this.showNext()
    },
    gender: function () {
      // this.showNext()
    }
  },
  methods: {
    changeBirthYearAction: function () {
      this.isBirthYearFontBlack = this.birthYear !== ''
      this.isDisabled = true
      if (this.birthYear && this.birthMonth && this.birthDay) {
        if (this.gender) {
          this.isDisabled = false
          if (this.isFix) {
            this.btnContent = '更新'
          } else {
            this.btnContent = '次へ'
          }
        }
      }
    },
    changeBirthMonthAction: function () {
      this.isBirthMonthFontBlack = this.birthMonth !== ''
      this.isDisabled = true
      if (this.birthYear && this.birthMonth && this.birthDay) {
        if (this.gender) {
          this.isDisabled = false
          if (this.isFix) {
            this.btnContent = '更新'
          } else {
            this.btnContent = '次へ'
          }
        }
      }
    },
    changeBirthDayAction: function () {
      this.isBirthDayFontBlack = this.birthDay !== ''
      this.isDisabled = true
      if (this.birthYear && this.birthMonth && this.birthDay) {
        if (this.gender) {
          this.isDisabled = false
          if (this.isFix) {
            this.btnContent = '更新'
          } else {
            this.btnContent = '次へ'
          }
        }
      }
    },
    changeGenderAction: function () {
      this.isDisabled = true
      if (this.birthYear && this.birthMonth && this.birthDay) {
        if (this.gender) {
          this.isDisabled = false
          if (this.isFix) {
            this.btnContent = '更新'
          } else {
            this.btnContent = '次へ'
          }
        }
      }
    },
    showNext: function () {
      this.show.next = false
      if (this.birthYear && this.birthMonth && this.birthDay) {
        if (this.gender) {
          this.show.next = true
          this.autoScroll()
        }
      }
    },
    clickFixBirthdayAndGender: function () {
      this.show.answer_1 = false
      this.show.answer_2 = false
      this.isFix = true
      this.isDisabled = true
      this.$emit('form-fix-birthday-and-gender', {
        birthYear: this.birthYear,
        birthMonth: this.birthMonth,
        birthDay: this.birthDay,
        gender: this.gender
      })
      this.$emit('form-next')
      // this.show.answer_1 = false
      // this.show.answer_2 = false
      // this.show.next = false
      this.show.fix = true
      this.autoScroll()
    },
    changeFixBirthdayAndGender: function () {
      if (this.isFix) {
        this.$emit('form-change-birthday-and-gender', {
          birthYear: this.birthYear,
          birthMonth: this.birthMonth,
          birthDay: this.birthDay,
          gender: this.gender
        })
        this.isDisabled = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/import/var";
.fade {
  &-enter-active, &-leave-active {
    will-change: opacity;
    transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
  &-enter, &-leave-to {
    opacity: 0;
  }
}
.fontBlack {
  color: #000;
}
.chat-item--select {
  .chat-item__inr {
    .select--col3 {
      @include mq-max("390px") {
        width: 67%;
        flex-wrap: wrap;
      }
      select {
        @include mq-max("390px") {
          margin-bottom: 3px;
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forms/FormBirthdayAndGender.vue